import SecaoSerraPark from './SecaoSerraPark';

export { SecaoSerraPark };

export default SecaoSerraPark;
